function setBaseClassState(sceneObject, newState) {
  sceneObject.setState(newState);
}

export { setBaseClassState };
//# sourceMappingURL=utils.js.map
